import { Injectable } from '@angular/core';
import { CanActivate, Router, CanActivateChild } from '@angular/router';
import { AuthService } from '@pg-app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { StoreProvider } from '@pg-app/core/services/storeProvider/store.provider';
import { PortalType } from '@pg-app/core/Enum/Authentication/PortalType';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router, private store: StoreProvider, private toastService: ToastrService) { }

  async canActivate() {

    const isAuthenticated = await this.authService.isAuthenticated();

    if (isAuthenticated) {
      const portalTypes = this.store.get('portalTypes');
      const current_URL = window.location.href;

      if (!portalTypes) {
        return true;
      }

      if (current_URL.indexOf('/client') > -1 && (portalTypes.indexOf(PortalType.ClientPortal) === -1)) {
        this.toastService.error('You are not enabled for access to this portal. Let the Tech Guys know if you believe you have encountered this message in error', '', {
          timeOut: 60000
        }
        );
        return false;
      }

      if (current_URL.indexOf('/partner') > -1 && (portalTypes.indexOf(PortalType.PartnerPortal) === -1)) {
        this.toastService.error('You are not enabled for access to this portal. Let the Tech Guys know if you believe you have encountered this message in error', '', {
          timeOut: 60000
        });
        return false;
      }

      return true;
    }

    this.router.navigate(['/auth', 'login']);
    return false;
  }

  async canActivateChild() {
    return await this.canActivate();
  }
}
